import { render, staticRenderFns } from "./ortherSupport.vue?vue&type=template&id=129d0f05&"
import script from "./ortherSupport.vue?vue&type=script&lang=js&"
export * from "./ortherSupport.vue?vue&type=script&lang=js&"
import style0 from "./ortherSupport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports